var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyCardBenefitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589844,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#EAF8E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5914_39374)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5914_39374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 16.5898H13C12.4 16.5898 12 16.9898 12 17.5898V27.5898C12 28.1898 12.4 28.5898 13 28.5898H27C27.6 28.5898 28 28.1898 28 27.5898V17.5898C28 16.9898 27.6 16.5898 27 16.5898ZM23.1 26.5898H16.9C16.5 25.1898 15.4 24.0898 14 23.6898V21.4898C15.4 21.0898 16.5 19.9898 16.9 18.5898H23.2C23.6 19.9898 24.7 21.0898 26.1 21.4898V23.7898C24.6 24.0898 23.5 25.1898 23.1 26.5898Z",
    fill: "#97DD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24.5898C21.1046 24.5898 22 23.6944 22 22.5898C22 21.4853 21.1046 20.5898 20 20.5898C18.8954 20.5898 18 21.4853 18 22.5898C18 23.6944 18.8954 24.5898 20 24.5898Z",
    fill: "#97DD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 12.5898H14V14.5898H26V12.5898Z",
    fill: "#97DD7C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5914_39374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5898)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5914_39374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5898)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCardBenefitIcon);
export default __webpack_public_path__ + "static/media/money-card-benefit-icon.8de55dfdd5f2b2b3f9d0778fa3e68e5c.svg";
export { ForwardRef as ReactComponent };